import { RefObject, useState, useEffect } from 'react'
import { Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { DayPicker } from 'react-day-picker'
import { useTranslation } from 'react-i18next'

export default function DateModal({ date, modalRef, onSetDate }: { modalRef: RefObject<HTMLDialogElement>, date?: Date | string | null, onSetDate: (date: Date | null) => void}) {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<Date | undefined>(date ? new Date(date) : undefined)

  // Sync internal state when the external date prop changes
  useEffect(() => {
    setSelected(date ? new Date(date) : undefined)
  }, [date])

  function handleConfirm() {
    onSetDate(selected ?? null)
    modalRef.current?.close()
  }

  return <Modal ref={modalRef} responsive backdrop={true}>
    <Modal.Header>
      {t('common.selectDate')}
    </Modal.Header>
    <Modal.Body className='flex justify-center items-center flex-col gap-2'>
      <DayPicker
        mode='single'
        selected={selected}
        onSelect={(day) => setSelected(day ?? undefined)}
        fixedWeeks
      />
      <form method="dialog">
        <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
      </form>
      <Button color='primary' onClick={handleConfirm}>{t('common.select')}</Button>
    </Modal.Body>
  </Modal>
}
